export function format(n: number, isOffset: boolean = true) {
  const offset = isOffset ? 100 : 10
  return (Math.round(n / offset) * offset).toLocaleString("ja-JP", { style: "currency", currency: "JPY" })
}

export function sum(prices: number[]) {
  return prices.length === 0 ? 0 : prices.reduce((accumulator, curr) => accumulator + curr)
}

export function kv<T>(data: T[], key = "id"): { [P in string]: T } {
  return Object.fromEntries(data.map(item => [item[key], item]))
}

export function mergeEntries<T>(data: [string, T][]): { [P in string]: T[] } {
  const newDataSource = {}
  data.forEach(item => {
    const target = item[0]
    if (!newDataSource[target]) {
      newDataSource[target] = []
    }
    newDataSource[target].push(item[1])
  })
  return newDataSource
}

export function mergeSum<T>(data: T[], sumKey: string, mergeKey: string = "id"): T[] {
  const newDataSource = {}
  data.forEach(item => {
    const target = item[mergeKey]
    if (newDataSource[target]) {
      newDataSource[target] = { ...item, [sumKey]: newDataSource[target][sumKey] + item[sumKey] }
    } else {
      newDataSource[target] = item
    }
  })
  return Object.values(newDataSource)
}

export function deepCopy<T>(data: T): T {
  return JSON.parse(JSON.stringify(data))
}

export const toHalfWidth = (str: string) => str.replace(/[０-９]/g, (tmpStr) => {
  return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0)
})

export function unique<T>(data: T[], key: string = "id"): T[] {
  return Object.values(kv(data.filter(item => item), key))
}